import React, { useContext, useState, useEffect } from 'react';
import { Form, Input, Button, Checkbox, Select, Pagination, Spin, Tabs, Table, Tag, Space, Tooltip, Modal, Radio, message, Row, Col, Card } from 'antd';
import Moment from 'react-moment';

import api from '../../../api';
import RolesMask from '../../../helpers/rolesMask';

import './users.css';
import { BiPlusCircle, BiCog, BiEditAlt, BiTrash } from "react-icons/bi";
import { Context } from '../../../context/AuthContext';
import { value } from 'numeral';
import { CheckOutlined, SearchOutlined, ExclamationCircleOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';

// import Filter from './filter';
// import EditCustomer from './editCustomer';
// import AddCustomer from './addCustomer';
// import List from './list';

function Users() {
    const { userData } = useContext(Context);

    const [user, setUser] = useState({})
    const [modalUser, setModalUser] = useState(false);
    const [loadUser, setLoadUser] = useState(false)

    const [formEdit] = Form.useForm();

    function selectUser(id) {
        let user = users.filter((item) => {
            return item._id == id
        })[0]
        setUser(user)
        setRole(user.roles[0])

        formEdit.setFieldsValue({
            "name": user.name,
            "email": user.email,
            "role": user.roles[0],
        });

        // Set selected users
        if (user.roles[0] === "supervisor" && user.users.length) {
            user.users.forEach(userId => {
                selectUserList(userId);
            })
        }

        setModalUser(true)
    }

    const [users, setUsers] = useState([])
    const [modalNewUser, setModalNewUser] = useState(false)
    const [loadNewUser, setLoadNewUser] = useState(false)
    const [role, setRole] = useState('call-center')

    const [listUsers, setListUsers] = useState([]);
    const [totalUsersSelected, setTotalUsersSelected] = useState(0);

    const [modalDelete, setModalDelete] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [loadDelete, setLoadDelete] = useState(false);
    const [customerCount, setCustomerCount] = useState(0);
    const [customersList, setCustomersList] = useState([]);
    const [showCustomersList, setShowCustomersList] = useState(false);
    const [loadingCustomerCount, setLoadingCustomerCount] = useState(false);

    useEffect(() => {
        (async () => {
            const { data } = await api.get('/users');
            setUsers(data);

            let _usersList = [];
            data.forEach(item => {
                _usersList.push({
                    id: item._id,
                    name: item.name,
                    email: item.email,
                    role: item.roles[0],
                    selected: false,
                    hidden: false
                })
            })
            console.log(_usersList)
            setListUsers(_usersList);

        })();
    }, []);

    const onFinish = async values => {
        const selectedUsers = listUsers.filter(user => user.selected)

        setLoadNewUser(true)
        let newUser = {
            name: values.name,
            email: values.email,
            password: values.password,
            role: role
        }

        if (selectedUsers.length) {
            newUser.users = selectedUsers.map(user => { return user.id })
        }

        await api.post('/users', newUser).then(async response => {
            const { data } = await api.get('/users');
            setUsers(data)
            setModalNewUser(false)
            setLoadNewUser(false)
            message.success('Usuário criado com suceesso!');
        }).catch(error => {
            console.log(error)
            setLoadNewUser(false)
            message.error('Erro ao criar novo cliente.');
        })
    };

    const onFinishUser = async values => {
        const selectedUsers = listUsers.filter(user => user.selected)

        if (selectedUsers.length) {
            values.users = selectedUsers.map(user => { return user.id })
        }

        setLoadUser(true)
        await api.patch(`/users/${user._id}`, values).then(async response => {
            const { data } = await api.get('/users');
            setUsers(data)
            setModalUser(false)
            setLoadUser(false)
            clearSelectedUsers()
            message.success('Usuário atualizado com suceesso!');
        }).catch(error => {
            console.log(error)
            setLoadNewUser(false)
            message.error('Erro ao criar novo cliente.');
        })
    };

    function changeRole(e) {
        setRole(e.target.value)
    }

    const columns = [
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Permissões',
            key: 'roles',
            dataIndex: 'roles',
            render: tags => (
                <>
                    {tags.map(tag => {
                        let color = tag == 'call-center' ? 'geekblue' : 'cyan';
                        if (tag === 'admin') {
                            color = 'green';
                        }
                        if (tag === 'supervisor') {
                            color = 'magenta';
                        }
                        return (
                            <Tag color={color} key={tag}>
                                <RolesMask user={tag} />
                            </Tag>
                        );
                    })}
                </>
            ),
        },
        {
            title: 'Último login',
            dataIndex: 'lastLogin',
            key: 'lastLogin',
            render: lastLogin => <span>{<Moment format="DD/MM/YYYY  H:mm">{lastLogin}</Moment>}</span>,
        },
        {
            title: 'Criado dia',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: createdAt => <span>{<Moment format="DD/MM/YYYY">{createdAt}</Moment>}</span>,
        },
        {
            title: 'Ações',
            key: 'action',
            render: (text, record) => (
                <Space size="middle">
                    <Tooltip title="Editar Usuário">
                        <Button type="default" icon={<BiEditAlt />} onClick={() => selectUser(record._id)} size="small"></Button>
                    </Tooltip>
                    <Tooltip title="Excluir Usuário">
                        <Button
                            type="default"
                            danger
                            icon={<BiTrash />}
                            onClick={() => openDeleteModal(record)}
                            size="small"
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    const selectUserList = async (userId) => {
        let _users = listUsers.map(item => {
            if (item.id == userId) {
                if (item.selected) {
                    item.selected = false;
                } else {
                    item.selected = true;
                }
            }
            return item;
        })
        setListUsers(_users);
        setTotalUsersSelected(_users.filter(item => item.selected).length);
    }

    const filterUsers = async (search) => {
        let _usersList = listUsers.map(item => {
            if (item.name.toLowerCase().search(search.toLowerCase()) !== -1 || item.email.toLowerCase().search(search.toLowerCase()) !== -1) {
                item.hidden = false;
            } else {
                item.hidden = true;
            }
            return item;
        });
        setListUsers(_usersList)
    }

    const clearSelectedUsers = async () => {
        let _users = listUsers.map(item => {
            item.selected = false;
            return item;
        })
        setListUsers(_users);
        setTotalUsersSelected(0);
    }

    const openDeleteModal = async (record) => {
        setUserToDelete(record);
        setModalDelete(true);
        setShowCustomersList(false);
        setLoadingCustomerCount(true);
        try {
            const { data } = await api.get(`/users/${record._id}/customers/count`);
            setCustomerCount(data.count);
            setCustomersList(data.customers || []);
        } catch (error) {
            setCustomerCount(0);
            setCustomersList([]);
        }
        setLoadingCustomerCount(false);
    };

    const handleDelete = async () => {
        setLoadDelete(true);
        try {
            await api.delete(`/users/${userToDelete._id}`);
            const { data } = await api.get('/users');
            setUsers(data);

            // Atualizar lista de usuários para supervisor
            let _usersList = [];
            data.forEach(item => {
                _usersList.push({
                    id: item._id,
                    name: item.name,
                    email: item.email,
                    role: item.roles[0],
                    selected: false,
                    hidden: false
                })
            })
            setListUsers(_usersList);

            setModalDelete(false);
            setUserToDelete(null);
            setCustomerCount(0);
            setCustomersList([]);
            setShowCustomersList(false);
            message.success('Usuário excluído com sucesso!');
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Erro ao excluir usuário.';
            message.error(errorMsg);
        }
        setLoadDelete(false);
    };

    return (
        <>
            <div className="add-user" onClick={() => setModalNewUser(true)}>
                <BiPlusCircle size="20px" />
                <span>Criar novo usuário</span>
            </div>
            <Table columns={columns} dataSource={users} />

            <Modal
                visible={modalNewUser}
                title="Criar novo usuário"
                onCancel={() => setModalNewUser(false)}
                footer={false}
                centered
                width={800}
                maskClosable={false}
            >
                <div className="add-customer-step-1">
                    <Form
                        labelCol={{ span: 5 }}
                        wrapperCol={{ span: 16 }}
                        layout="horizontal"
                        onFinish={onFinish}
                    >
                        <Form.Item label="Nome" name="name" rules={[{ required: true, message: 'Nome é obrigatório' }]} >
                            <Input />
                        </Form.Item>

                        <Form.Item label="Email" name="email" rules={[{ required: true, message: 'Email é obrigatório' }]} >
                            <Input />
                        </Form.Item>


                        <Form.Item label="Senha" name="password" rules={[{ required: true, message: 'Senha é obrigatório' }]} >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item label="Nível de acesso" name="role">
                            <Radio.Group defaultValue="call-center" buttonStyle="solid" onChange={(e) => changeRole(e)}>
                                <Radio.Button value="call-center" defaultChecked>Atendente</Radio.Button>
                                <Radio.Button value="specialist">Especialista</Radio.Button>
                                <Radio.Button value="supervisor">Supervisor</Radio.Button>
                                <Radio.Button value="admin">Administrador</Radio.Button>
                            </Radio.Group>
                        </Form.Item>

                        {role === "supervisor" &&
                            <Row>
                                <Col span={5}></Col>
                                <Col span={16}>
                                    <div className='select_users_list'>
                                        <p><i>Um usuário supervisor, precisa de usuários relacionados a ele, <br /> escolha os usuários na lista abaixo:</i></p>

                                        <p>Usuários selecionados: <strong>{totalUsersSelected}</strong>/{listUsers.length}</p>
                                        <Input
                                            prefix={<SearchOutlined />}
                                            placeholder="Filtrar usuários por nome ou e-mail"
                                            onChange={(e) => filterUsers(e.target.value)}
                                            allowClear
                                        />
                                        <ul>
                                            {listUsers && listUsers.map((user, i) => {
                                                let tag = user.role;
                                                let color = tag == 'call-center' ? 'geekblue' : 'cyan';
                                                if (tag === 'admin') color = 'green';
                                                if (tag === 'supervisor') color = 'magenta';

                                                return (
                                                    <li key={i} className={`${user.selected ? 'active' : ''} ${user.hidden ? 'hidden' : ''} `}>
                                                        <div className="selector" onClick={() => { selectUserList(user.id) }}>
                                                            <CheckOutlined style={{ fontSize: '14px' }} />
                                                        </div>
                                                        <div className='user'>
                                                            <div>
                                                                <span className='name'>{user.name}</span>
                                                                <span>{user.email}</span>
                                                            </div>
                                                            <Tag className='tag' color={color}>
                                                                <RolesMask user={user.role} />
                                                            </Tag>
                                                        </div>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        }

                        <div className="add-customer-form-footer">
                            <Button className="green" type="primary" htmlType="submit" style={{ width: "200px" }} loading={loadNewUser}>Confirmar</Button>
                        </div>

                    </Form>
                </div>
            </Modal>

            <Modal
                visible={modalUser}
                title="Editar usuário"
                onCancel={() => {
                    setModalUser(false);
                    clearSelectedUsers();
                }}
                footer={false}
                centered
                width={800}
            >
                <div className="add-customer-step-1">
                    <Form
                        labelCol={{ span: 5 }}
                        wrapperCol={{ span: 16 }}
                        layout="horizontal"
                        onFinish={onFinishUser}
                        form={formEdit}
                    >

                        <Form.Item label="Nome" name="name" rules={[{ required: true, message: 'Nome é obrigatório' }]} >
                            <Input />
                        </Form.Item>

                        <Form.Item label="Email" name="email" rules={[{ required: true, message: 'Email é obrigatório' }]} >
                            <Input disabled />
                        </Form.Item>

                        <Form.Item label="Senha" name="password" >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item label="Nível de acesso" name="role">
                            <Radio.Group defaultValue="call-center" buttonStyle="solid" onChange={(e) => changeRole(e)}>
                                <Radio.Button value="call-center" defaultChecked>Atendente</Radio.Button>
                                <Radio.Button value="specialist">Especialista</Radio.Button>
                                <Radio.Button value="supervisor">Supervisor</Radio.Button>
                                <Radio.Button value="admin">Administrador</Radio.Button>
                            </Radio.Group>
                        </Form.Item>

                        {role === "supervisor" &&
                            <Row>
                                <Col span={5}></Col>
                                <Col span={16}>
                                    <div className='select_users_list'>
                                        <p><i>Um usuário supervisor, precisa de usuários relacionados a ele, <br /> escolha os usuários na lista abaixo:</i></p>

                                        <p>Usuários selecionados: <strong>{totalUsersSelected}</strong>/{listUsers.length}</p>
                                        <Input
                                            prefix={<SearchOutlined />}
                                            placeholder="Filtrar usuários por nome ou e-mail"
                                            onChange={(e) => filterUsers(e.target.value)}
                                            allowClear
                                        />
                                        <ul>
                                            {listUsers && listUsers.map((user, i) => {
                                                let tag = user.role;
                                                let color = tag == 'call-center' ? 'geekblue' : 'cyan';
                                                if (tag === 'admin') color = 'green';
                                                if (tag === 'supervisor') color = 'magenta';

                                                return (
                                                    <li key={i} className={`${user.selected ? 'active' : ''} ${user.hidden ? 'hidden' : ''} `}>
                                                        <div className="selector" onClick={() => { selectUserList(user.id) }}>
                                                            <CheckOutlined style={{ fontSize: '14px' }} />
                                                        </div>
                                                        <div className='user'>
                                                            <div>
                                                                <span className='name'>{user.name}</span>
                                                                <span>{user.email}</span>
                                                            </div>
                                                            <Tag className='tag' color={color}>
                                                                <RolesMask user={user.role} />
                                                            </Tag>
                                                        </div>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        }

                        <div className="add-customer-form-footer">
                            <Button className="green" type="primary" htmlType="submit" style={{ width: "200px" }} loading={loadUser}>Confirmar</Button>
                        </div>

                    </Form>
                </div>
            </Modal>

            <Modal
                visible={modalDelete}
                title="Excluir usuário"
                onCancel={() => {
                    setModalDelete(false);
                    setUserToDelete(null);
                    setCustomerCount(0);
                    setCustomersList([]);
                    setShowCustomersList(false);
                }}
                footer={[
                    <Button key="cancel" onClick={() => {
                        setModalDelete(false);
                        setUserToDelete(null);
                        setCustomerCount(0);
                        setCustomersList([]);
                        setShowCustomersList(false);
                    }}>
                        Cancelar
                    </Button>,
                    <Button
                        key="delete"
                        type="primary"
                        danger
                        loading={loadDelete}
                        disabled={loadingCustomerCount || customerCount > 0}
                        onClick={handleDelete}
                        style={
                            (loadingCustomerCount || customerCount > 0)
                                ? { backgroundColor: '#ff4d4f', borderColor: '#ff4d4f', color: '#fff', opacity: 0.5 }
                                : {}
                        }
                    >
                        Excluir
                    </Button>
                ]}
                centered
            >
                {loadingCustomerCount ? (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <Spin />
                        <p style={{ marginTop: '10px' }}>Verificando clientes vinculados...</p>
                    </div>
                ) : customerCount > 0 ? (
                    <>
                        <p>Não é possível excluir o usuário <strong>{userToDelete?.name}</strong>.</p>
                        <div style={{
                            backgroundColor: '#fff1f0',
                            border: '1px solid #ffa39e',
                            borderRadius: '4px',
                            padding: '12px 16px',
                            color: '#cf1322',
                            marginBottom: '12px'
                        }}>
                            <p style={{ margin: 0 }}>
                                Existem <strong style={{ fontSize: '16px' }}>{customerCount}</strong> cliente(s) vinculado(s) a este usuário.
                            </p>
                        </div>
                        <p style={{ color: '#888' }}>
                            Para excluir este usuário, primeiro remova ou transfira todos os clientes vinculados a ele.
                        </p>
                        <Button
                            type="link"
                            onClick={() => setShowCustomersList(!showCustomersList)}
                            style={{ padding: 0, display: 'flex', alignItems: 'center', gap: '6px' }}
                        >
                            {showCustomersList ? (
                                <>Ocultar clientes <UpOutlined /></>
                            ) : (
                                <>Ver clientes <DownOutlined /></>
                            )}
                        </Button>
                        {showCustomersList && (
                            <div style={{
                                maxHeight: '200px',
                                overflowY: 'auto',
                                marginTop: '12px',
                                border: '1px solid #d9d9d9',
                                borderRadius: '4px'
                            }}>
                                {customersList.map((customer, index) => (
                                    <div
                                        key={customer._id}
                                        style={{
                                            padding: '8px 12px',
                                            borderBottom: index < customersList.length - 1 ? '1px solid #f0f0f0' : 'none',
                                            backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff'
                                        }}
                                    >
                                        <strong>{customer.company || customer.name || 'Sem nome'}</strong>
                                        {customer.document && (
                                            <span style={{ color: '#888', marginLeft: '8px', fontSize: '12px' }}>
                                                {customer.document}
                                            </span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        <p>Tem certeza que deseja excluir o usuário <strong>{userToDelete?.name}</strong>?</p>
                        <div style={{
                            backgroundColor: '#fff3cd',
                            border: '1px solid #ffc107',
                            borderRadius: '4px',
                            padding: '12px 16px',
                            color: '#856404',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            <ExclamationCircleOutlined style={{ fontSize: '18px' }} />
                            <span>O usuário será excluído e não poderá mais fazer login no sistema.</span>
                        </div>
                    </>
                )}
            </Modal>

        </>
    )

}


export default Users;
